<template>
  <div class = "eDN">
    <div class="menuSideBar">
      <Menu :menu="menuItems" @menuClicked="menuClicked" />
    </div>

    <div class="mainContent">

      <div class="filterBar">
        <div class="statusFilterContainer">
          <div class="statusFilterButton" :style="{'background-color': showStatus.pending ? 'rgb(255, 255, 153)' : 'rgb(136, 136, 136)'}" @click="toggleStatus('pending')">
            <div class="statusIcon"><img :src="showStatus.pending ? 'https://dsmlib.logistics.systems/Icons/ClockBlack.png' : 'https://dsmlib.logistics.systems/Icons/ClockWhite.png'"></div>
            <div class="statusLabel" :style="{'text-decoration': showStatus.pending? 'initial' : 'line-through', color: showStatus.pending ? 'black' : 'white'}">Pending</div>
            <div class="statusCounter" :style="{'text-decoration': showStatus.pending ? 'initial' : 'line-through', color: showStatus.pending ? 'black' : 'white'}">{{eDNcount.pending}}</div>
          </div>
          <div class="statusFilterButton" :style="{'background-color': showStatus.sent ? 'rgb(231, 150, 3)' : 'rgb(136, 136, 136)'}" @click="toggleStatus('sent')">
            <div class="statusIcon"><img :src="showStatus.sent ? 'https://dsmlib.logistics.systems/Icons/SendBlack.png' : 'https://dsmlib.logistics.systems/Icons/SendWhite.png'"></div>
            <div class="statusLabel" :style="{'text-decoration': showStatus.sent ? 'initial' : 'line-through', color: showStatus.sent ? 'black' : 'white'}">Sent</div>
            <div class="statusCounter" :style="{'text-decoration': showStatus.sent ? 'initial' : 'line-through', color: showStatus.sent ? 'black' : 'white'}">{{eDNcount.sent}}</div>
          </div>
          <div class="statusFilterButton" :style="{'background-color': showStatus.accepted ? 'rgb(121, 210, 121)' : 'rgb(136, 136, 136)'}" @click="toggleStatus('accepted')">
            <div class="statusIcon"><img :src="showStatus.accepted ? 'https://dsmlib.logistics.systems/Icons/CheckmarkBlack.png' : 'https://dsmlib.logistics.systems/Icons/CheckmarkWhite.png'"></div>
            <div class="statusLabel" :style="{'text-decoration': showStatus.accepted ? 'initial' : 'line-through', color: showStatus.accepted ? 'black' : 'white'}">Accepted</div>
            <div class="statusCounter" :style="{'text-decoration': showStatus.accepted? 'initial' : 'line-through', color: showStatus.accepted ? 'black' : 'white'}">{{eDNcount.accepted}}</div>
          </div>
          <div class="statusFilterButton" :style="{'background-color': showStatus.rejected ? 'rgb(255, 77, 77)' : 'rgb(136, 136, 136)'}" @click="toggleStatus('rejected')">
            <div class="statusIcon"><img :src="showStatus.rejected ? 'https://dsmlib.logistics.systems/Icons/CrossmarkBlack.png' : 'https://dsmlib.logistics.systems/Icons/CrossmarkWhite.png'"></div>
            <div class="statusLabel" :style="{'text-decoration': showStatus.rejected ? 'initial' : 'line-through', color: showStatus.rejected ? 'black' : 'white'}">Rejected</div>
            <div class="statusCounter" :style="{'text-decoration': showStatus.rejected ? 'initial' : 'line-through', color: showStatus.rejected ? 'black' : 'white'}">{{eDNcount.rejected}}</div>
          </div>
        </div>

        <div class="generalFilterContainer">
          <div class="generalFilterContent" style="text-align: right;">{{filtersSummary}}</div>
          <div class="generalFilterContent">
            <button @click="showChangeFilterPopup = !showChangeFilterPopup;">Change Filter</button>
            <div v-if="showChangeFilterPopup" class="changeFilterPopup">
              <div class="changeFilterPopupItemContainer">
                <div class="changeFilterPopupItemFields" style="flex-direction: row;">
                  Transporter: <Dropdown placeholder="Transporter" :items="transporterFilterItems" itemKey="transporter" :selectedObject.sync="selectedTransporter" :isRequired="true" :errorMessage.sync="transporterFilterError" textAlign="left" />
                </div>
              </div>
              <div class="changeFilterPopupItemContainer">
                <CheckBox class="changeFilterPopupItemCheckbox" title="Date" :isChecked="useDateFilter" @checkBoxClicked="useDateFilter = !useDateFilter" />
                <div class="changeFilterPopupItemFields" style="flex-direction: row;">
                  <DateTimePicker placeholder="Start" :showTime="false" :value.sync="fStartDate" :maxDate="fEndDate" :isDisabled="!useDateFilter" :errorMessage.sync="fStartDError" />
                  <DateTimePicker placeholder="End" :showTime="false" :value.sync="fEndDate" :minDate="fStartDate" :isDisabled="!useDateFilter" :errorMessage.sync="fEndDError" />
                </div>
              </div>
              <div class="changeFilterPopupItemContainer">
                <CheckBox class="changeFilterPopupItemCheckbox" title="Search" :isChecked="useSearchFilter" @checkBoxClicked="useSearchFilter = !useSearchFilter" />
                <div class="changeFilterPopupItemFields" style="flex-direction: column;">
                  <Dropdown placeholder="Search By" :items="searchByItems" itemKey="searchBy" :selectedObject.sync="searchBy" :isDisabled="!useSearchFilter" :isRequired="useSearchFilter" :errorMessage.sync="searchByError" textAlign="left" />
                  <Dropdown placeholder="Search Criteria" :items="criteriaOptions" itemKey="criteria" :selectedObject.sync="searchCriteria" :isDisabled="!useSearchFilter" :isRequired="useSearchFilter" :errorMessage.sync="searchCriteriaError" textAlign="left" />
                  <Input placeholder="Search" :inputValue.sync="searchKeyword" :isDisabled="!useSearchFilter" :isRequired="useSearchFilter" :errorMessage.sync="searchKeywordError" />
                </div>
              </div>
              <div class="changeFilterPopupRefreshButton">
                <button @click="refreshClicked">Refresh</button>
              </div>
            </div>
          </div>
          <div class="generalFilterContent">Last Refreshed: {{$dateTime.getDateTime(lastRefreshed, "yyyy-MM-dd HH:mm")}}</div>
        </div> 
      </div> <!-- End of filter bar -->

        <div class="eDNTableBoxContainer">
          <TableBox v-if="showeDNTable" :tableData="eDNTable" title="e-DeliveryNote(s)" :downloadName="`eDNs_${selectedTransporter.value}_${$dateTime.getDateTime(null, 'yyyy-MM-dd')}`" :maxSelection="-1" :selectedRow.sync="selectedeDN" :additionalIconsIndex="[0]" :loading="loadTable" :dataType="eDNTableDataType" />
        </div> <!-- End of table box container -->

    <div v-if="showConfirmPopup" class="confirmationPopupContainer">
      <div class="confirmationPopup">
        <div class="dnDetailsContainer">

        <table class="summaryHeader">
          <tr>
            <td>To</td>
            <td>:</td>
            <td><b>{{selectedTransporter['fn']}} 
              ({{selectedTransporter['transporter']}})</b></td>
          </tr>
          <tr>
            <td>e-Delivery Note(s)</td>
            <td>:</td>
            <td><div v-html="selectedeDNString"></div></td>
          </tr>
        </table>

          <div v-for="(eDN, index) of selectedeDN" :key="eDN['Delivery Note #']" class="dnDetails">
            <div class="dnDetailsHeader">
              <table>
                <tr>
                  <td>Delivery Note #</td>
                  <td>:</td>
                  <td>{{eDN['Delivery Note #']}}</td>
                </tr>
                <tr>
                  <td>Transporter</td>
                  <td>:</td>
                  <td>{{eDN['Transporter']}}</td>
                </tr>
                <tr>
                  <td>Pickup</td>
                  <td>:</td>
                  <td>{{eDN['Pickup']}}</td>
                </tr>
                <tr>
                  <td>Dropoff</td>
                  <td>:</td>
                  <td>{{eDN['Dropoff']}}</td>
                </tr>
                <tr>
                  <td>Vehicle #</td>
                  <td>:</td>
                  <td>{{eDN['Vehicle #']}}</td>
                </tr>
                <tr>
                  <td>Driver</td>
                  <td>:</td>
                  <td>{{eDN['Driver']}}</td>
                </tr>
              </table>
              <div class="dnDetailsHeaderPrintContainer">
                <button class="dnDetailsHeaderPrintButton" @click="printDN(index)"><img src="https://img.icons8.com/android/96/000000/print.png" style="height: 20px; width: 20px"> Print Delivery Note</button>
              </div> <!-- End of print button -->
            </div>

            <div> <!-- Start of attachment container -->
              <div class="eDNAttachmentsContainer">
                <div class="eDNAttachmentsTableBox">
                  <TableBox :title="`${eDN['Delivery Note #']} Attachments`" :tableData="attachmentsTableData[index]" :maxSelection="-1" :selectedRow.sync="selectedAttachments[index]" :hideColumns="['DocumentGUID', 'AttImage']" :dataType="{ 'Date Added':'date' }" />
                </div>
                <div class="eDNAddAttachmentsContainer">
                  <div><Input textType="file" placeholder="Browse" @fileChanged="fileChanged($event, index)" :ref="`addAttachmentInput ${index}`" /></div>
                  <div><Input placeholder="Remarks" :inputValue.sync="addAttachmentRemarks[index]" /></div>
                  <div><button @click="addAttachment(index)">Add Attachment</button></div>
                </div>
              </div>
              <div><span v-if="selectedAttachmentsList(index)">Selected attachments: <strong>{{ selectedAttachmentsList(index) }}</strong></span></div>
            </div> <!-- End of attachment container -->

            <hr v-if="index + 1 < selectedeDN.length" class="dnDetailsSeparator"> <!-- dont render if it is the last selectedeDNT -->
          </div><!-- End of e-delivery note details -->
        </div> <!-- End of e-delivery note details container -->

        <div class="sendCancelButtonsContainer">
          <div class="sendCancelButton">
            <button @click="sendeDN()">Send</button>
          </div>
          <div class="sendCancelButton">
            <button @click="showConfirmPopup = false">Cancel</button>
          </div>
        </div>

      </div>
    </div> <!-- End of confirmation popup -->

    </div>

    <PopupV2 :show="showPopup" :type="popupType" :title="popupTitle" :content="popupContent" @buttonClicked="showPopup = false"/>
    <Loader :isVisible="loadPage" :loadingText="loadPageText" :isFullScreen="true" />

  </div> <!-- End of main -->
</template>

<script>
/* eslint-disable */
import axios from 'axios';

import Menu from '@/components/Menus.vue';
import Designer from '@/components/reportDesigner/Designer.vue';

export default {
  components: {
    Menu, Designer
  }, // End of components
  data() {
    return {

      /* Data for menus component (side) */
      menuItems: [
        {title: 'Send eDelivery Note', icon: 'https://dsmlib.logistics.systems/Icons/SendBlack.png'}
      ],

      /* Boolean check for filter */
      showStatus: {
        pending: true,
        sent: false,
        accepted: false,
        rejected: false,
      },

      /* Counters to show status */
      eDNcount: {
        pending: 0,
        sent: 0,
        accepted: 0,
        rejected: 0
      },


      /* Search options */
      filtersSummary: "",
      lastRefreshed: new Date(),
      showChangeFilterPopup: false,

      /* Transporter code dropdown */
      transporterFilterItems: [],
      selectedTransporter: {},
      transporterFilterError: '',

      /* Date Filter */
      useDateFilter: true,
      // first day of current month
      fStartDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      fStartDError: '',
      fEndDate: new Date(),
      fEndDError: '',

      /* Search by filter */
      useSearchFilter: false,
      searchByItems: [
        {"searchBy": "Delivery Note No", value: "Delivery Note #"},
        {"searchBy": "Job No", value: "Job #"},
        {"searchBy": "Reference No", value: "Reference #"},
        {"searchBy": "Package Code", value: "Package Code"},
        {"searchBy": "Vehicle No", value: "Vehicle #"},
      ],
      searchBy: {"searchBy": "Delivery Note No", value: "Delivery Note #"},
      searchByError: "",

      /* Criteria filter */
      criteriaOptions: [
        { "criteria":"CONTAINS" },
        { "criteria":"EQUALS" },
        { "criteria":"STARTS WITH" },
        { "criteria":"ENDS WITH" },
      ],

      searchCriteria: {"criteria": "CONTAINS"},
      searchCriteriaError: '',
      searchKeyword: '',
      searchKeywordError: '',

      /* eDN and table data */
      eDNList: [],
      showeDNTable: true,
      eDNTable: [],
      eDNTableDataType: {
        "Delivery Not Date": 'date',
        "Quantity": 'number',
        "KG": 'number',
        "M3": 'number',
      },
      
      // Selected eDN from box
      selectedeDN: [],
      loadTable: false,
      showConfirmPopup: false,
      
      // Attachment data
      attachmentsTableData: [],
      selectedAttachments: [],
      addAttachmentFiles: [],
      addAttachmentRemarks: [],

      // Delivery Note details of selected eDN
      DNDetails: {},

      /* Popup entry data */
      showPopup: false,
      popupType: '',
      popupTitle: '',
      popupContent: '',

      // Loading screen for entire page
      loadPage: false,
      loadPageText: 'Default Loading Text'
    }
  }, // End of data
  computed: {
    // Generates the string of selected eDN for user to see
    selectedeDNString () {
      if (this.selectedeDN.length <= 0){
        return ''
      }
        let eDNString = `<b>${this.selectedeDN[0]['Delivery Note #']}</b>`;
        for(let i=1; i < this.selectedeDN.length; i++){
          eDNString += `, <b>${this.selectedeDN[i]['Delivery Note #']}</b>`
        }
        return eDNString;
      }
  }, // End of computed
  methods: {
    refreshTable: function(data = []){
      this.eDNTable = [];
      this.$nextTick(() => {
        this.eDNTable = data;
      })
    },
    menuClicked: async function(item) {
      switch(item.title){
        case 'Send eDelivery Note':{
          // Nothing is selected
          if(this.selectedeDN.length <= 0){
            this.popupType = "error";
            this.popupTitle = "No eDeliveryNote(s) Selected"
            this.popupContent = "Please select at least one eDeliveryNote to send"
            this.showPopup = true;
            return
          }

          for (let eDN of this.selectedeDN){
            if(eDN['eDN Status'] == 'Rejected'){
              this.popupType = "error";
              this.popupTitle = "A Rejected eDeliveryNote was Selected"
              this.popupContent = "Please ensure the selected eDeliveryNote(s) has not been rejected"
              this.showPopup = true;
              return
            }
          }
          
          await this.getDNDetails();

          //#region Getting all the attachments that have no ROTReport and generate them
          let indexToCreateReport = [];
          this.attachmentsTableData.forEach((ra, ind) => {
            let hasReport = ra.find(a => a['File Name'].includes('eDN_'));
            if (!hasReport) {
              indexToCreateReport.push(ind);
            }
          });
          
          this.$fullscreenLoading('Generating Report');
          for (let icr of indexToCreateReport) {
            let b64 = await this.createDeliveryNoteReport(this.dnDetails[this.selectedeDN[icr]['Delivery Note #']]);
            this.addAttachmentFiles[icr].push({
              name: `eDN_${this.selectedeDN[icr]['Transporter']}_${this.selectedeDN[icr]['Delivery Note #'].replace(/\//g, '')}.pdf`,
              type: 'application/pdf',
              fileAtt: b64,
            });
            this.addAttachmentRemarks[icr] = 'Auto Generated report';
            
            await this.addAttachment(icr, true);
          }
          this.$fullscreenLoading();
          //#endregion

          if (indexToCreateReport.length > 0) {
            await this.getDNDetails();
          }

          this.showConfirmPopup = true;
          break;
        }
      }
    },
    createDeliveryNoteReport: async function(data) {
      if (data['ROTDate']) {
        data['ROTDate'] = new Date(data['ROTDate']).formatString(this.$store.state['preferredDateFormat']);
      }
      if (data['Date_ETA']) {
        data['Date_ETA'] = new Date(data['Date_ETA']).formatString(this.$store.state['preferredDateFormat']);
      }
      
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      data['companyHeader'] = loginDetails.CoHeaderOpr ? loginDetails.CoHeaderOpr : '';
      data['companyName'] = loginDetails.CoName ? loginDetails.CoName : '';
      return await this.generateReport(data);
    },
    generateReport: async function(reportData) {
      let resolve = null;
      let prom = new Promise(r => resolve = r);

      let data = {
        template: { shortid: 'BJl6F_jNVD' },
        data: reportData,
        options: { 'Content-Disposition': 'attachment;filename=report.pdf'}
      };
      let headerInfo = {
        'Content-Type': 'application/json',
        'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
      };
      try {
        let jsReportPDF = await axios.post('https://dsm.logistics.systems:5488/api/report', data, { headers: headerInfo, responseType: 'arraybuffer' });
        let contentType = jsReportPDF.headers['content-type'];
        let pdfBlob = new Blob([ jsReportPDF.data ], { type: contentType });
        
        let reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onload = () => {
          resolve(reader.result.split(',')[1]);
        };
      } catch(e) {
        console.log(e);
      }

      return prom;
    },
    toggleStatus: async function(status){
      switch(status){
        case 'pending':
          this.showStatus.pending = !this.showStatus.pending; break;
        case 'sent':
          this.showStatus.sent = !this.showStatus.sent; break;
        case 'accepted':
          this.showStatus.accepted = !this.showStatus.accepted; break;
        case 'rejected':
          this.showStatus.rejected = !this.showStatus.rejected; break;
      }

      // this.eDNTable = [];
      this.showeDNTable = false;
      await this.$nextTick();
      this.eDNTable = this.statusFilter();
      let dnnoTemp = this.selectedeDN.map(m => m['Delivery Note #']);
      this.selectedeDN = this.eDNTable.filter(f => dnnoTemp.includes(f['Delivery Note #']));
      this.showeDNTable = true;
    },
    statusFilter(){
      let filtered = this.eDNList;
      let onStatus = [];

      // Status checks with their respective filters
      for(let status in this.showStatus){
        if (this.showStatus[status.toLowerCase()]) {
          onStatus.push(status);
        }
        filtered = filtered.filter((eDN) => {
          return !(eDN['eDN Status'].toLowerCase() == status.toLowerCase() && !this.showStatus[status])
        });
      }

      //remove any records which the status is toggle off already
      this.selectedeDN = JSON.parse(JSON.stringify(this.selectedeDN.filter(f => onStatus.includes(f['eDN Status'].toLowerCase()))));

      // Recounts status filter
      this.countStatusFilter()
      return filtered
    },
    countStatusFilter(){
      for(let status in this.eDNcount){
        this.eDNcount[status] = this.eDNList.filter((eDN) => { 
          return eDN['eDN Status'].toLowerCase() == status.toLowerCase() }).length
      }
    },
    updateFiltersSummary() {
      // let filterString = `To {this.s}`
      // this.filtersSummary
    },
    async refreshClicked() {
      this.loadPageText = "Refreshing data"
      this.loadPage = true
      var fieldsAreEmpty = false;

      if(!this.selectedTransporter){
        this.transporterFilterError = "Select a transporter"
        fieldsAreEmpty = true
      }

      // Check if date filters are filled
      if(this.useDateFilter){
        if(!this.fStartDate){
          this.fStartDError = "Enter a start date"
          fieldsAreEmpty = true
        }
        if(!this.fEndDate){
          this.fEndDError = "Enter an end date"
          fieldsAreEmpty = true
        }
      }

      // Check if search by and criterias filters are filled
      if(this.useSearchFilter){
        if(!this.searchBy){
          this.searchByError = "Choose a field to search by";
          fieldsAreEmpty = true
        }
        if(!this.searchCriteria){
          this.searchCriteriaError = "Choose a search criteria";
          fieldsAreEmpty = true
        }
        if(!this.searchKeyword){
          this.searchKeywordError = "Enter a keyword to search for"
          fieldsAreEmpty = true
        }
      }

      if(fieldsAreEmpty){
        this.loadPage = false
        return
      }

      this.showChangeFilterPopup = false;
      this.loadPageText = "Getting e-Delivery Notes";
      this.loadPage = true;
      this.loadTable = true;
      await this.geteDNList();

      // Search filter the results
      if(this.useSearchFilter){
          switch (this.searchCriteria['criteria']) {
            case 'CONTAINS':
              this.eDNList = this.eDNList.filter((eDN) => { return eDN[this.searchBy['value']].includes(this.searchKeyword); });
              break;

            case 'EQUALS':
              this.eDNList = this.eDNList.filter((eDN) => { return eDN[this.searchBy['value']] == this.searchKeyword; });
              break;

            case 'STARTS WITH':
              this.eDNList = this.eDNList.filter((eDN) => { return eDN[this.searchBy['value']].startsWith(this.searchKeyword); });
              break;

            case 'ENDS WITH':
              this.eDNList = this.eDNList.filter((eDN) => { return eDN[this.searchBy['value']].endsWith(this.searchKeyword); });
              break;
          }
      }

      // Add the respective icons
        this.eDNList = this.eDNList.map(eDN => { // append status icons
          switch (eDN['eDN Status']) {
            case 'Pending':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/ClockBlack.png' }, eDN);
              break;

            case 'Sent':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/SendBlack.png' }, eDN);
              break;

            case 'Accepted':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusComplete.png' }, eDN);
              break;

            case 'Rejected':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusCancelled.png' }, eDN);
              break;    
          }
        })

      this.refreshFilterSummary();

      this.eDNTable = []
      this.selectedeDN = []
      this.$nextTick(() => {
        this.eDNTable = this.statusFilter()
        this.loadPage = false;
        this.loadTable = false;
      })

    },
    refreshFilterSummary(){
      let summaryText = `To ${this.selectedTransporter['fn']} (${this.selectedTransporter['transporter']}), `;
      summaryText += `From ${this.$dateTime.getDateTime(this.fStartDate, "yyyy-MM-dd")} `
      summaryText += `To ${this.$dateTime.getDateTime(this.fEndDate, "yyyy-MM-dd")}`
      this.filtersSummary = summaryText
    },
    async geteDNList(){
      // let startDate = this.fStartDate.toISOString().split('T')[0];
      // let endDate = this.fEndDate.toISOString().split('T')[0];
      let startDate = this.fStartDate.formatString("yyyy-MM-dd");
      let endDate = this.fEndDate.formatString("yyyy-MM-dd");
      this.eDNList = await this.$apiCallV2(`/DeliveryNotes/GeteDN?transporter=${this.selectedTransporter.value}&stdeliverydate=${startDate}&eddeliverydate=${endDate}`);
    },
    async getDNDetails(){
      this.$fullscreenLoading('Getting Delivery Note Details');
      this.dnDetails = {}
      this.addAttachmentFiles = [];
      this.addAttachmentRemarks = [];
      if (this.attachmentsTableData.length > 0) { this.attachmentsTableData.forEach((a, i) => this.$set(this.attachmentsTableData, i, [])) }
      else { this.attachmentsTableData = [] }
      if (this.selectedAttachments.length > 0) { this.selectedAttachments.forEach((a, i) => this.$set(this.selectedAttachments, i, [])) }
      else { this.selectedAttachments = [] }

      // await this.$sleep(1000);
      for (let i = 0; i < this.selectedeDN.length; i++) {
        let eDN = this.selectedeDN[i];
        this.dnDetails[eDN['Delivery Note #']] = (await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteDetails?dnno=${eDN['Delivery Note #']}`))[0];
        this.addAttachmentFiles.push([]);
        this.addAttachmentRemarks.push('');
        if (this.attachmentsTableData[i]) {
          // console.log('tabledata found')
          this.$set(this.attachmentsTableData, i, await this.getAllAttachment(eDN['Job #'], eDN['Delivery Note #']))
        }
        else {
          // console.log('tabledata not found')
          this.attachmentsTableData.push(await this.getAllAttachment(eDN['Job #'], eDN['Delivery Note #']))
        }
        if (this.selectedAttachments[i]) {
          // console.log('attachments found')
          this.$set(this.selectedAttachments, i, [])
        }
        else {
          // console.log('attachments not found')
          this.selectedAttachments.push([])
        }

        //auto select the eDN to be send. 
        let DNpdf = this.attachmentsTableData[i].find(f => f['Remarks'].trim().toLowerCase() == "auto generated report" && f['File Name'].includes('eDN_'));
        if (DNpdf) {
          this.selectedAttachments[i].push(DNpdf);
        }
      }

      console.log(this.dnDetails);
      console.log(this.addAttachmentFiles, this.addAttachmentRemarks, this.attachmentsTableData, this.selectedAttachments);

      this.$fullscreenLoading();
    },
    getMostRecenteDNJSONBody: async function(jobNo, eDNNo) {
      let mostRecenteDNJSONBody = await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${jobNo}`);
      return mostRecenteDNJSONBody.filter((doc) => {
        return doc['Doc Code'] == 'eDN' && doc['Reference No'] == eDNNo && doc['AttImageName'].endsWith('.json') // filter out files that do not fit this criteria
      }).map((doc) => {
        let JSONCounter = doc['AttImageName'].split('_'); // get the counter value from the file name
        JSONCounter = JSONCounter[JSONCounter.length - 1].split('.')[0].trim();

        return { // map each json file to a json object containing the contents of the file and the counter value
          "JSONBody":doc['AttImage'],
          "JSONCounter":parseInt(JSONCounter)
        };
      }).sort((first, second) => { // sort the json files according to the counter in descending order (the one with the highest counter is the most recent one)
        return first['JSONCounter'] > second['JSONCounter'] ? -1 : 1;
      })[0]; // get the most recent json file (index 0)
    },
    getAllAttachment: async function(jobno, dnno) {
      let allAttachment = await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${jobno}`);
      return allAttachment.filter(d => d['Doc Code'] == 'eDN' && d['Reference No'] == dnno && d['Remarks'] != "eDN Auto Generated JSON").map(d => {
        return {
          'File Name': d['AttImageName'],
          'Date Added': d['Received DateTime'],
          'Remarks': d['Remarks'],
          'AttImage': d['AttImage'],
          'DocumentGUID': d['DocumentGUID'],
        }
      });
    },
    selectedAttachmentsList: function(index) { // generates a string containing selected attachment filenames separated by commas
      if (this.selectedAttachments[index].length == 0) // e.g. test.txt, test2.txt, test3.txt
        return '';                                     // generated string is displayed in confirmation popup

      let list = this.selectedAttachments[index][0]['File Name'];
      for (let i = 1; i < this.selectedAttachments[index].length; i++) {
        list += `, ${this.selectedAttachments[index][i]['File Name']}`;
      }

      return list;
    },
    printDN(index){
      // Redirect the use to the report printing page
      let dnno = this.selectedeDN[index]['Delivery Note #'];
      let route = this.$router.resolve(`/${this.$route.params['user']}/ReportsV2/Delivery Note?dn=${dnno.split('/').join('%2f')}`);
      // Opens a new tab
      window.open(route.href, '_blank');
    },
    fileChanged(file, index) {
      this.addAttachmentFiles[index] = file;
    },
    async addAttachment(index, isBase64) {
      if (this.addAttachmentFiles[index].length == 0) {
        this.$showAlert('error', 'No File Selected', 'There are no file selected to upload');
      } else {
        this.$fullscreenLoading('Uploading Attachment');
        
        let jobNo = this.selectedeDN[index]['Job #'];
        let document = [{
          "Doc Code": "eDN",
          "Doc Ref #": this.selectedeDN[index]['Delivery Note #'],
          "Attachment": this.addAttachmentFiles[index][0]['name'],
          "Remarks": this.addAttachmentRemarks[index],
          "Status": "",
          "Start Date": "",
          "Received Date": "",
          "system": "eSendDN",
          "Due Date": "",
          "Assign To": "",
          "Sets": "",
          "Page": "",
          "documentguid": "",
          "statusseqno": "",
          "fileAtt": isBase64 ? this.addAttachmentFiles[index][0]['fileAtt'] : await this.addAttachmentFiles[index][0].toBase64(true),
          "filetype": this.addAttachmentFiles[index][0]['type'],
          "Action": "N"
        }];

        if (!document[0]['Attachment'] || document[0]['Attachment'] == '' || !document[0]['filetype']) {
          this.$showAlert('error', 'Add attachment failed', 'Your file is not suitable to upload!');
        } else if (document[0]['Attachment'] == '' || !document[0]['fileAtt'] || !document[0]['filetype']) {
          this.$showAlert('error', 'Add attachment failed', 'Your file is empty!');
        } else {
          let saveJobDocument = await this.$apiCallV2(`/DeliveryNotes/SaveJobDocument?jobno=${jobNo}`, { 'documents': document });
          if (saveJobDocument[0]['Results'] != 0) { // if failed to upload attachment
            this.$showAlert('error', 'Add attachment failed', saveJobDocument[0]['ErrMsg']);
          } else if (!isBase64) {
            await this.getDNDetails();
          }
        }

        this.$fullscreenLoading();
      }
    },
    async sendeDN(){
      this.$fullscreenLoading('Preparing to send Delivery Note');
      let senderConfigCode = (await this.$apiCallV2('/Login/GetDetails'))['ConfigCode'];
      let currentDateTime = new Date();
      let count = 0;
      for(let edn of this.selectedeDN){
        let details = this.dnDetails[edn['Delivery Note #']]
        this.$fullscreenLoading(`Sending Delivery Note ${edn['Delivery Note #']}`);
        let toPost = {
          "action": "", // Generate after 
          "cu_number": details['Cu_Number'], 
          "ShprCsgn": details['ShprCsgn'],
          "ShprCsgnName": details['ShprCsgnName'],
          "ShprCsgnSName": details['ShprCsgnSName'],
          "billto": details['BillTo'],
          "BillToName": details['BillToName'],
          "BillToSName": details['BillToSName'],
          // "billto": "FREMAN07",
          "job_no": details['Job_No'],
          "job_type": details['Job_Type'],
          "cmr_no": details['RefNo'],
          "transporter": edn['Transporter'],
          "indicator": details['Ind'],
          "orderno": details['ROTNo'],
          "voyno": details['VoyNo'],
          "date_eta": this.$dateTime.getDateTime(details['Date_ETA'], "yyyy-MM-dd"),
          job_date: new Date(details['ROTDate']).formatString('yyyy-MM-dd'),
          "daterequired": new Date(details['ROTDate']).formatString('yyyy-MM-dd'),
          "timerequired": details['ROTTime'], // ROT Time 
          "lorryno": details['VehicleNo'],
          "driver": edn['Driver'],
          "drivername": details['DriverName'],
          "driveric": details['DriverNRIC'],
          "pickup": details['DepartureCode'],
          "pickup_company": details['FromCompany'],
          "pickup_attn": details['FromAttn'],
          "pickup_addr1": details['FromAdd1'],
          "pickup_addr2": details['FromAdd2'],
          "pickup_addr3": details['FromAdd3'],
          // "pickup_addr4": details['FromAdd4'],
          "pickup_postcode": details['FromPostCode'],
          "pickup_city": details['FromCity'],
          "pickup_state": details['FromState'],
          "pickup_country": details['FromCountry'],
          "pickup_phone": details['FromPhone'],
          "pickup_email": "",
          "dropoff": details['DestinationCode'],
          "dropoff_company": details['ToCompany'],
          "dropoff_attn": details['ToAttn'],
          "dropoff_addr1": details['ToAdd1'],
          "dropoff_addr2": details['ToAdd2'],
          "dropoff_addr3": details['ToAdd3'],
          // "dropoff_addr4": details['ToAdd4'],
          "dropoff_postcode": details['ToPostCode'],
          "dropoff_city": details['ToCity'],
          "dropoff_state": details['ToState'],
          "dropoff_country": details['ToCountry'],
          "dropoff_phone": details['ToPhone'],
          "dropoff_email": '',
          "bookingsource": 'A', // W for portal, A for system to system
          "system": 'CONTLESS',
          "senderco": edn['Transporter'],
          "goodsdescription": details['GoodsDescription'],
          "shippingmarks": details['ShipMarks'],
          "consignments": [
            {
              "seqno": "1",
              "packageqty": details['Quantity'],
              "remarks1": details['Remarks'],
              "package_code": details['Package_Code'],
              "packageweight": details['GWeight'],
              "packagem3": details['Measurement'],
              "remarks2": ""
            }
          ],
          "attachments": [],
          "eDN_API": this.selectedTransporter['API_URL'],
          "senderconfigcode": senderConfigCode,
          "configcode": this.selectedTransporter['API_URL'],
          "autorequestno": ''
        } // End of toPost

        // Trim eDN no
        edn['Delivery Note #'] = edn['Delivery Note #'].trim()

        for(let data in toPost) { 
          // Defaults empty data to ''
          if(!toPost[data]){
            toPost[data] = '' 
          }

          // Trim the white spaces of post data(s)
          if(typeof(toPost[data]) === "string"){
            toPost[data] = toPost[data].trim()
          }
        }

        // PREPARE ATTACHMENTS
        let documentGUID = []; // used for UpdateStatusTask call later
        for (let attachment of this.selectedAttachments[count]) {
          documentGUID.push(attachment['DocumentGUID']);
          let doc = details['Doc'].filter((doc) => { return doc['Document GUID'] == attachment['DocumentGUID']; })[0]; // find corresponding doc from rotDetails
          // needed because selectedAttachments only has filename, remarks and GUID
          // file data and file type aren't copied into selectedAttachments to reduce memory usage
          if (doc) {
            toPost['attachments'].push({
              "doc_code": "ATT",
              // "doc_refno": doc['File Name'],
              "doc_refno": details['ROTNo'],
              "doc_image": doc['Doc Image'],
              "doc_imagetype": doc['File Type'],
              "doc_name": doc['File Name'],
              "doc_remark": doc['Doc Remark']
            });
          }
        }

        // PREPARE ACTION
        let eDNJSONFileCount;
        if((edn['eDN Status'] == 'Pending')){
          toPost['action'] = 'N'
          // There is no JSON files sent as request is sent for the first time
          eDNJSONFileCount = 0;
        } else {
          toPost['action'] = 'E'

          try {
            let mostRecenteDNJSONBody = await this.getMostRecenteDNJSONBody(toPost['job_no'], edn['Delivery Note #']); // get the most recent JSON file
            eDNJSONFileCount = mostRecenteDNJSONBody["JSONCounter"];
            // The request body in the JSON file is stored as base 64, atob to convert to text.
            toPost['autorequestno'] = JSON.parse(decodeURIComponent(atob(mostRecenteDNJSONBody['JSONBody'])))['autorequestno'];
          } catch (e) {
            console.log(e);
            this.popupType = 'error';
            this.popupTitle = 'Sending e-Delivery Note failed';
            this.popupContent = `eDN# ${edn['Delivery Note #']}: ${saveResponse[0]['ErrMsg']}`;
            this.showPopup = true;
            this.$fullscreenLoading('');
            return;
          }
        }

        toPost['action'] = (edn['eDN Status'] == 'Pending') ?  'N' : 'E'

        // Sending eDN
        let saveResponse = await this.$apiCallV2('/DeliveryNotes/SaveComBooking', toPost)
        if(saveResponse[0]['Results'] != 0){
            this.popupType = 'error';
            this.popupTitle = 'Sending e-Delivery Note failed';
            this.popupContent = `eDN# ${edn['Delivery Note #']}: ${saveResponse[0]['ErrMsg']}`;
            this.showPopup = true;
            this.$fullscreenLoading('');
            return;
        }

        // Update the autorequestno to the post data to save to JSON body
        try {
          toPost['autorequestno'] = saveResponse[0]['AutoRequestNo']
          // remove attachment data from SaveCOMBBooking request body, the file already exists in the forwarder's database, no need to store a duplicate
          if (toPost['attachments'] && toPost['attachments'].length > 0) {
            for (let i = 0; i < toPost['attachments'].length; i++) {
              delete toPost['attachments'][i]['doc_image']; 
              toPost['attachments'][i]['doc_GUID'] = documentGUID[i]; // storing the GUID is good enough
            }
          }
          
          let toUpdateStatusPost = {
            "jobNo": toPost['job_no'],
            "ednNo": edn['Delivery Note #'],
            "remarks": "eDN Auto Generated JSON",
            "actstartdate": this.$dateTime.getDateTime(currentDateTime, "yyyy-MM-dd"),
            "actstarttime": this.$dateTime.getDateTime(currentDateTime, "HHmm"),
            "File Name": `eDN_${edn['Delivery Note #']}_${this.$dateTime.getDateTime(currentDateTime, "yyyy-MM-dd")}_${eDNJSONFileCount + 1}.json`,
            "File Type": "application/json",
            "File Data": btoa(encodeURIComponent(JSON.stringify(toPost))) // Save to base64
          }

          await this.$apiCallV2('/DeliveryNotes/UpdateStatusTask', toUpdateStatusPost)

        } catch (ex) {
            this.popupType = 'error';
            this.popupTitle = 'Sending e-Delivery Note failed';
            this.popupContent = `eDN# ${edn['Delivery Note #']}: ${saveResponse[0]['ErrMsg']}`;
            this.showPopup = true;
            this.$fullscreenLoading('');
            return;
        }

        // this.loadPage = false;
        this.$fullscreenLoading('');
        this.popupType = 'success';
        this.popupTitle = 'Sending e-Delivery Note(s) success';
        this.popupContent = `Successfully sent ${this.selectedeDNString} to ${this.selectedTransporter['fn']}`;
        this.showPopup = true;
        this.showConfirmPopup = false;
        this.refreshClicked();

        count += 1
      }
    }
    
  }, // End of methods
  async mounted(){
    // Getting transporter lists for dropdown
    this.loadPageText = 'Getting Transporters';
    this.loadPage = true
		let transporterList = await this.$apiCallV2('/DeliveryNotes/GetListMaster?masterFile=creditor_edn');
    var firstEntry = transporterList.shift();
    this.selectedTransporter = {
      "transporter": firstEntry['Transporter Code'].trim() , 
      value: firstEntry['Transporter Code'].trim(), 
      fn: firstEntry['Transporter Name'], 
      "API_URL": firstEntry['API URL']
    }
    this.transporterFilterItems.push(this.selectedTransporter)
    for(let t of transporterList){
      
      this.transporterFilterItems.push({
        "transporter": t['Transporter Code'].trim(), 
        fn: t['Transporter Name'],
        "API_URL": t['API URL']
      })
      
    }

    // Getting e-Delivery notes
    this.loadPageText = 'Getting e-Delivery notes'
    this.loadTable = true
    await this.refreshClicked()
    this.loadTable = false
  }, // End of mounted
}
</script>

<style>

.eDN{
  width: 100%;
  height: 100%;
  padding: 8px 10px 8px 42px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  /* // border: 1px solid red; */
}

.mainContent {
  width: 100%;
  height: 100%;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.filterBar {
  background-color: white;
  display: flex;
  flex-direction: row;
  margin: 0 0 5px 0;
  border-radius: 5px;
  /* border: 1px solid red; */
}

.statusFilterContainer {
  display: flex;
  flex-direction: row;
  margin: 5px 5px 5px 5px;
  justify-content: right;
  flex: 1.5;
  /* // border: 1px solid red; */
}

.statusFilterButton {
  height: 100px;
  width: 100px;
  border: 1px solid black;
  border-radius: 3px;
  margin: 0 5px 0 5px;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.statusIcon > img {
  height: 30px;
  width: 30px;
  margin: 5px 0 2px 0;
  /* // border: 1px solid red; */
}

.statusLabel {
  font-size: 14px;
  margin: 0 0 3px 0;
  /* // border: 1px solid red; */
}

.statusCounter {
  font-size: 18px;
  /* // border: 1px solid red; */
}

.generalFilterContainer {
  margin: auto 5px auto 5px;
  padding-right: 5px;
  justify-content: right;
  flex: 1.6;
  /* // border: 1px solid red; */
}

.generalFilterContent {
  display: flex;
  justify-content: right;
  margin: 5px 0 5px 0;
  /* // border: 1px solid red; */
}

.changeFilterPopup {
  position: absolute;
  margin-top: 29px;
  height: fit-content;
  width: 320px;
  background-color: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 5px 10px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.changeFilterPopupItemContainer {
  position: relative;
  width: 100%;
}

.changeFilterPopupItemCheckbox {
  position: absolute;
  width: fit-content;
  top: -5px;
  left: 3%;
  padding: 0 10px;
  background-color: white;
}

.changeFilterPopupItemFields {
  border: 1px solid black;
  border-radius: 5px;
  width: 100%;
  margin: 5px 0 10px 0;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.changeFilterPopupRefreshButton {
  width: 100%;
  text-align: right;
}

.eDNTableBoxContainer {
  background-color: white;
  border-radius: 5px;
  padding: 0 5px 5px 5px;
  height: 100%;
  overflow: hidden;
}

.confirmationPopupContainer {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirmationPopup {
  background-color: white;
  /* // z-index: 99999; */
  width: 80%;
  height: 95%;
  position: absolute;
  padding: 5px;
  display: flex;
  flex-direction: column;
  /* // border: 1px solid red; */
}

.summaryHeader {
  margin-bottom: 10px;
  display: block;
  /* // border: 1px solid red; */
}

.dnDetailsContainer {
  margin-bottom: 10px;
  overflow-y: scroll;
  border: 1px solid black;
}

.dnDetails {
  height: auto;
  /* // border: 1px solid red; */
}

.dnDetailsHeader {
  display: flex;
  flex-direction: row;
  border: 1px solid black;
}

.dnDetailsHeaderPrintContainer {
  display: flex;
  justify-content: right;
  align-items: center;
  flex: 1;
  /* // border: 1px solid red; */
}

.dnDetailsHeaderPrintButton {
  margin-right: 10px;
}

.eDNAttachmentsContainer {
  display: flex;
  flex-direction: row;
  border: 1px solid black;
}

.eDNAttachmentsTableBox {
  flex: 5;
  overflow-x: hidden;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.eDNAddAttachmentsContainer {
  flex: 2;
  margin: 40px 5px 10px 5px;
}

.dnDetailsSeparator {
  border-top: 2px dashed black;
}

.sendCancelButtonsContainer {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* // border: 1px solid red; */
}

.sendCancelButton {
  margin: 0 5px;
}


</style>